<template>
  <div class="onoffswitch">
    <input
      class="onoffswitch-checkbox"
      type="checkbox"
      :id="id"
      :disabled="disabled"
      :checked="isChecked"
      @change="onToggle"
    />

    <label class="onoffswitch-label" :for="id">
      <span
        class="onoffswitch-inner"
        :data-true="trueLabel"
        :data-false="falseLabel"
      ></span>
      <span class="onoffswitch-switch"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: "OnOffSwitch",

  model: {
    prop: "value",
    event: "input",
  },

  props: {
    disabled:{
      type: Boolean,
      default: false
    },
    value: {
      required: true,
    },
    trueValue: {
      default: true,
    },
    falseValue: {
      default: false,
    },
    trueLabel: {
      type: String,
      default: "ON",
    },
    falseLabel: {
      type: String,
      default: "OFF",
    },
    id: {
      type: String,
      default() {
        return "onoff_" + Math.random().toString(36).substr(2, 9);
      },
    },
  },

  computed: {
    isChecked() {
      return this.value === this.trueValue;
    },
  },

  methods: {
    onToggle(e) {
      const checked = e.target.checked;
      const newVal = checked ? this.trueValue : this.falseValue;

      this.$emit("input", newVal); // v-model
      this.$emit("change", newVal); // handler eksternal
    },
  },
};
</script>
<style scoped>
.onoffswitch {
  margin-left: auto;
  position: relative;
  width: 73px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.onoffswitch-checkbox {
  display: none;
}
.onoffswitch-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border-radius: 20px;
  margin-bottom: 0;
}
.onoffswitch-inner {
  display: block;
  margin-left: -100%;
  transition: margin 0.3s ease-in 0s;
  width: 200%;
}
.onoffswitch-inner:before,
.onoffswitch-inner:after {
  box-sizing: border-box;
  color: #fff;
  display: block;
  float: left;
  font-size: 16px;
  height: 30px;
  line-height: 32px;
  padding: 0;
  width: 50%;
}
.onoffswitch-inner:before {
  background-color: #55ce63;
  color: #fff;
  content: "ON";
  padding-left: 14px;
}
.onoffswitch-inner:after {
  content: "OFF";
  padding-right: 14px;
  background-color: #ccc;
  color: #fff;
  text-align: right;
}
.onoffswitch-switch {
  background: #fff;
  border-radius: 20px;
  bottom: 0;
  display: block;
  height: 20px;
  margin: 5px;
  position: absolute;
  right: 43px;
  top: 0;
  transition: all 0.3s ease-in 0s;
  width: 20px;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
  margin-left: 0;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
  right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomSwitch.vue